import { format, isToday } from 'date-fns';
import { transformAddress } from './transformAddress';
import { ru, enUS } from 'date-fns/locale';

export function timestampToDate(timestamp) {
  return new Date(timestamp * 1000);
}

export function groupTransactionsByDate(transactions, locale) {
  const localeMap = {
    ru: ru,
    en: enUS,
  };

  const groupedTransactions = transactions.reduce((acc, transaction) => {
    const date = timestampToDate(transaction.date);
    const dateKey = date.toDateString();

    let formattedDate;
    const atString = locale === 'ru' ? 'в' : 'at';

    if (isToday(date)) {
      formattedDate = locale === 'ru' ? 'Сегодня' : 'Today';
    } else {
      formattedDate = format(date, 'MMMM d', { locale: localeMap[locale] });
    }

    if (!acc[dateKey]) {
      acc[dateKey] = {
        date: formattedDate,
        transactions: [],
      };
    }

    const originalDate = new Date(transaction.date * 1000);
    const timeString = format(originalDate, 'HH:mm');

    acc[dateKey].transactions.push({
      ...transaction,
      date: timeString,
      address: transaction.address && transformAddress(transaction.address),
      originalAddress: transaction.address,
      dateDetail: format(originalDate, `d MMMM '${atString}' HH:mm`, {
        locale: localeMap[locale],
      }),
    });

    return acc;
  }, {});

  const result = Object.values(groupedTransactions).map((group) => ({
    ...group,
    transactions: group.transactions.sort((a, b) => b.date - a.date),
  }));

  return result;
}
